let dirPath = 'games/page007_game0';

let configGame = {
  autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { block: true },
    items: [
      {
        idGroup: 'target',
        idItem: 't1',
        items: [{ idGroup: 'source', idItem: 's1', correct: [{ idGroup: 'target', idItem: 't1' }] }],
      },
    ],
  },
  layout: {
    otherProperty: {
      maze: {
        mask: { src: dirPath + '/img/mask.png' },
        draw: {
          size: 10,
          correct: 'black',
        },
      },
    },
    groupsConfig: {
      positions: {
        type: 'absolute',
        pos: { y: 0, x: 0, width: 1920, height: 1080 },
      },
    },
    groups: [
      {
        idGroup: 'target',
        background: {
          image: { src: dirPath + '/img/t1.webp' },
        },
        items: [
          {
            id: 't1',
            background: {
              color: 'rgba(255,255,255,0.1)',
            },
            positions: { pos: { width: 1, height: 1, x: 0, y: 0 } },
          },
        ],
      },
      {
        idGroup: 'source',
        itemsConfig: {
          positions: { pos: { width: 1, height: 1, x: 0, y: 0 } },
          background: {
            color: 'rgba(255,255,255,0.1)',
          },
        },
        items: [
          {
            id: 's1',
            otherProperty: {
              maze: {
                draw: {
                  color: 'red',
                  start: 'blue',
                  stop: 'white',
                },
              },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'mazeDraw',
  fullscreen: true,
  blockCheck: true,
  withoutReset: true,
  // withoutCheck: true,
  configGame: configGame,
  // mainImage: {
  //   imagePath: dirPath + '/img/bgr.png',
  // },
};

export default dataConfig;
